"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDataQueryString = exports.createDataQueryString = exports.axiosFetch = exports.ECO_HEADER_KEYS = exports.ECO_HEADER_AUTH_KEYS = void 0;
const axios_1 = __importDefault(require("axios"));
const string_1 = require("./string");
exports.ECO_HEADER_AUTH_KEYS = ['X-Eco-Key', 'X-Eco-PubKey', 'X-Eco-Shopify-Access-Token', 'X-Eco-JWT'];
exports.ECO_HEADER_KEYS = [
    ...exports.ECO_HEADER_AUTH_KEYS,
    'X-Eco-CheckoutToken',
    'X-Eco-CartToken',
    'X-Eco-ShopName',
    'X-Eco-Shopify-Checkout-Authorization-Token'
];
const axiosFetch = (url, init) => {
    const config = {
        url,
        method: ((init === null || init === void 0 ? void 0 : init.method) || 'GET').toLowerCase(),
        responseType: 'json'
    };
    if (init === null || init === void 0 ? void 0 : init.headers)
        config.headers = init === null || init === void 0 ? void 0 : init.headers;
    if (init === null || init === void 0 ? void 0 : init.body)
        config.data = (0, string_1.isValidJSONString)(init === null || init === void 0 ? void 0 : init.body) ? JSON.parse(init.body) : init.body;
    return (0, axios_1.default)(config).then((res) => res.data);
};
exports.axiosFetch = axiosFetch;
/* -------------------------------- DataQuery ------------------------------- */
const createDataQueryString = (dataQuery) => {
    if (!dataQuery)
        return '';
    return encodeURIComponent(JSON.stringify(dataQuery));
};
exports.createDataQueryString = createDataQueryString;
const parseDataQueryString = (dataQueryString) => {
    if (!dataQueryString)
        return {};
    return dataQueryString ? JSON.parse(decodeURIComponent(dataQueryString)) : {};
};
exports.parseDataQueryString = parseDataQueryString;
